import { Component, Input } from '@angular/core';
import { PaymentFlowSnapshot } from '../../services/payment-flow-state.service';

@Component({
  selector: 'app-payment-status-card',
  templateUrl: './payment-status-card.component.html',
  styleUrls: ['./payment-status-card.component.scss'],
  standalone: false
})
export class PaymentStatusCardComponent {
  @Input() snapshot: PaymentFlowSnapshot | null = null;

  get phase(): string {
    return this.snapshot?.phase || 'idle';
  }

  get messageKey(): string {
    return `payments.status.${this.phase}`;
  }

  get isTerminal(): boolean {
    return this.phase === 'approved'
      || this.phase === 'declined'
      || this.phase === 'expired'
      || this.phase === 'voided'
      || this.phase === 'error';
  }
}
